import { Briefcase, MapPin, Clock } from 'lucide-react'
import { Link } from 'react-router-dom'

type JobCardProps = {
  cargo: string
  estabelecimento?: string
  descricao?: string
  localizacao?: string
  valorHora?: number
  foto?: string
  capa?: string
  data?: string
  contrato?: string
  href?: string
  onDetails?: () => void
}

const cargos: Record<string, string> = {
  garcom: 'Garçom', barman: 'Barman', churrasqueiro: 'Churrasqueiro',
  cozinheiro: 'Cozinheiro', auxiliar_cozinha: 'Auxiliar de Cozinha',
  lava_pratos: 'Lava-pratos', capo_sala: 'Chefe de Salão',
  recepcionista: 'Recepcionista', passador: 'Passador de Carne',
  bailarino: 'Bailarino', sommelier: 'Sommelier',
}

export default function JobCard(props: JobCardProps) {
  const cargo = cargos[props.cargo?.toLowerCase()] || props.cargo?.replace(/_/g, ' ') || 'Vaga'
  const date = props.data ? new Date(props.data) : null
  const dateText = date && !Number.isNaN(date.getTime()) ? date.toLocaleDateString('pt-BR') : null
  const contrato = ({fixa:'Fixo', temporaria:'Temporário', diaria:'Diária'} as Record<string,string>)[props.contrato || ''] || props.contrato
  const actionClass = 'mt-3 w-full flex items-center justify-center rounded-xl bg-[#E53935] px-4 py-2.5 text-sm font-bold text-white hover:bg-[#C62828] transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#E53935]'
  return (
    <article onClick={props.onDetails} className="group h-full w-full max-w-[300px] min-w-0 overflow-hidden rounded-2xl border border-[#E53935]/35 bg-[#2a2a2a] shadow-lg transition-shadow hover:shadow-xl flex flex-col">
      <div className="relative h-[200px] shrink-0 bg-[#1e1e1e]">
        {props.capa ? <img src={props.capa} alt="Foto de capa do estabelecimento" className="h-full w-full object-cover" loading="lazy" /> : <div className="h-full bg-gradient-to-br from-[#3E2723] to-[#1e1e1e]" />}
        {contrato && <span className="absolute top-3 right-3 rounded-full bg-[#C62828] px-3 py-1 text-xs font-semibold text-white">{contrato}</span>}
      </div>
      <div className="relative px-4 pb-4 flex flex-1 flex-col items-center">
        <div className="relative -mt-[72px] mb-2 h-[120px] w-[120px] shrink-0 overflow-hidden rounded-full border-4 border-[#2a2a2a] bg-white shadow-lg ring-1 ring-[#E53935]/40">
          {props.foto ? <img src={props.foto} alt={props.estabelecimento || 'Foto do estabelecimento'} className="h-full w-full object-cover" loading="lazy" /> : <div className="h-full w-full flex items-center justify-center bg-[#E53935] text-white"><Briefcase size={36} /></div>}
        </div>
        <h3 className="w-full text-center text-lg font-bold text-white leading-snug break-words capitalize">{cargo}</h3>
        {props.estabelecimento && <p className="mt-1 w-full text-center text-sm font-semibold text-gray-300 break-words">{props.estabelecimento}</p>}
        <p className="mt-2 mb-3 w-full text-center text-xs leading-5 text-gray-400 line-clamp-2 min-h-[40px]">{props.descricao || 'Consulte os detalhes desta oportunidade.'}</p>
        <div className="mt-auto w-full">
          <div className="rounded-lg bg-[#E53935]/10 px-3 py-2 text-center text-sm font-semibold text-[#E53935]">
            {typeof props.valorHora === 'number' && props.valorHora > 0 ? `${props.valorHora.toLocaleString('pt-BR', {style:'currency',currency:'EUR'})}/hora` : 'Remuneração não informada'}
          </div>
          <div className="mt-3 space-y-1.5 border-t border-[#E53935]/35 pt-2 text-xs text-gray-400">
            <p className="flex items-start gap-2"><MapPin size={14} className="shrink-0 text-[#E53935]" /><span className="break-words">{props.localizacao || 'Localização não informada'}</span></p>
            {dateText && <p className="flex items-center gap-2"><Clock size={14} className="shrink-0" /><span>Publicada em {dateText}</span></p>}
          </div>
          {props.onDetails ? <button type="button" onClick={(event) => { event.stopPropagation(); props.onDetails?.(); }} className={actionClass}>Ver detalhes</button> : <Link to={props.href || '/vagas'} className={actionClass}>Ver detalhes</Link>}
        </div>
      </div>
    </article>
  )
}
